import { render, staticRenderFns } from "./GameShops.vue?vue&type=template&id=9febc822&scoped=true&"
import script from "./GameShops.vue?vue&type=script&lang=js&"
export * from "./GameShops.vue?vue&type=script&lang=js&"
import style0 from "./GameShops.vue?vue&type=style&index=0&id=9febc822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9febc822",
  null
  
)

export default component.exports